var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "row my-4" },
    [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("section-title", {
            staticClass: "mt-4 mb-3",
            attrs: { "has-line": "", title: "Identificador de Proveedor" }
          })
        ],
        1
      ),
      _c("div", { staticClass: "row col-12 mb-3 align-items-stretch" }, [
        _c("div", { staticClass: "col-md-5 col-12 mb-3 mb-md-0" }, [
          _c("span", { staticClass: "font-weight-normal text-gray font-14" }, [
            _vm._v(" NPI Proveedor: ")
          ]),
          !_vm.isEditing && _vm.nationalIdentifier
            ? _c("p", { staticClass: "font-16 mb-0 mt-1" }, [
                _c("strong", [_vm._v(_vm._s(_vm.nationalIdentifier))])
              ])
            : _c(
                "div",
                { staticClass: "mt-1" },
                [
                  _c("custom-input", {
                    attrs: {
                      maxlength: "50",
                      placeholder: "Ingrese el NPI Proveedor"
                    },
                    model: {
                      value: _vm.nationalIdentifierDraft,
                      callback: function($$v) {
                        _vm.nationalIdentifierDraft = $$v
                      },
                      expression: "nationalIdentifierDraft"
                    }
                  })
                ],
                1
              )
        ]),
        _c("div", { staticClass: "col-md-5 col-12 mb-3 mb-md-0" }, [
          _c("span", { staticClass: "font-weight-normal text-gray font-14" }, [
            _vm._v(" Medicaid ID: ")
          ]),
          !_vm.isEditing && _vm.medicalIdentifier
            ? _c("p", { staticClass: "font-16 mb-0 mt-1" }, [
                _c("strong", [_vm._v(_vm._s(_vm.medicalIdentifier))])
              ])
            : _c(
                "div",
                { staticClass: "mt-1" },
                [
                  _c("custom-input", {
                    attrs: {
                      maxlength: "50",
                      placeholder: "Ingrese el Medicaid ID"
                    },
                    model: {
                      value: _vm.medicalIdentifierDraft,
                      callback: function($$v) {
                        _vm.medicalIdentifierDraft = $$v
                      },
                      expression: "medicalIdentifierDraft"
                    }
                  })
                ],
                1
              )
        ]),
        _c(
          "div",
          {
            staticClass: "col-md-2 col-12 pt-4",
            staticStyle: { "padding-top": "1.7rem !important" }
          },
          [
            _c("action-button", {
              staticClass: "ml-auto",
              attrs: {
                i: _vm.isEditing ? "fas fa-save" : "fas fa-edit",
                variant: _vm.isEditing ? "success" : "outline-success"
              },
              on: { click: _vm.onToggleEdit }
            })
          ],
          1
        )
      ]),
      !_vm.isAdding && !_vm.hasEligibilities
        ? _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "bg-secondary-3 p-3 mt-3 rounded" }, [
              _c("div", { staticClass: "upload-file-button__container" }, [
                _c("div", { staticClass: "panel-row-without-selector p-4" }, [
                  _c("div", { staticClass: "col-12 text-center" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn bg-light-white col-12 col-md-4",
                        attrs: { disabled: !_vm.hasNationalIdentifier },
                        on: {
                          click: function($event) {
                            _vm.isAdding = true
                          }
                        }
                      },
                      [
                        _c("em", {
                          staticClass: "fas fa-file-plus pr-4 text-green"
                        }),
                        _c(
                          "span",
                          { staticClass: "text-button-add-document" },
                          [
                            _vm._v(
                              " Presione aquí para añadir Elegibilidad Medicaid "
                            )
                          ]
                        )
                      ]
                    )
                  ])
                ])
              ])
            ])
          ])
        : _vm._e(),
      !_vm.isAdding && _vm.hasEligibilities
        ? _c(
            "div",
            { staticClass: "col-12 d-flex justify-content-end" },
            [
              _c(
                "action-button",
                {
                  attrs: {
                    disabled: !_vm.hasNationalIdentifier,
                    i: "fas fa-file-plus",
                    variant: "success"
                  },
                  on: {
                    click: function($event) {
                      _vm.isAdding = true
                    }
                  }
                },
                [_vm._v(" Añadir ")]
              )
            ],
            1
          )
        : _vm.isAdding
        ? _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "bg-secondary-3 p-3 mt-3 rounded" }, [
              _c("div", { staticClass: "upload-file-button__container" }, [
                _c("div", { staticClass: "panel-row-without-selector p-4" }, [
                  _c(
                    "div",
                    { staticClass: "col-12" },
                    [
                      _c("validation-observer", {
                        ref: "eligibilityObserver",
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function({ validate }) {
                              return [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-12 mb-3 d-flex align-items-center"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "eligibility-icon-wrapper mr-2"
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-clipboard-user"
                                          })
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass: "eligibility-title-text"
                                        },
                                        [_vm._v(" Elegibilidad de Medicaid ")]
                                      )
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3" },
                                    [
                                      _c("validation-provider", {
                                        attrs: { rules: "required" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function({ errors }) {
                                                return [
                                                  _c("custom-date-picker", {
                                                    staticClass:
                                                      "custom-date-picker__extended",
                                                    attrs: {
                                                      "custom-error-msg":
                                                        "Favor seleccionar Fecha Inicio.",
                                                      error: errors[0],
                                                      label: "Fecha Inicio:",
                                                      placeholder: "DD/MM/YYYY"
                                                    },
                                                    on: {
                                                      input:
                                                        _vm.onStartDateChange
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.eligibility
                                                          .startDate,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.eligibility,
                                                          "startDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "eligibility.startDate"
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-md-3" },
                                    [
                                      _c("validation-provider", {
                                        attrs: { rules: "required" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function({ errors }) {
                                                return [
                                                  _c("custom-date-picker", {
                                                    staticClass:
                                                      "custom-date-picker__extended",
                                                    attrs: {
                                                      "custom-error-msg":
                                                        "Favor seleccionar Fecha Fin.",
                                                      error: errors[0],
                                                      label: "Fecha Fin:",
                                                      "min-date":
                                                        _vm.eligibility
                                                          .startDate,
                                                      placeholder: "DD/MM/YYYY"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.eligibility.endDate,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.eligibility,
                                                          "endDate",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "eligibility.endDate"
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "col-md-6" }),
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "mt-3 mt-md-0",
                                        _vm.isOtherDocument
                                          ? "col-md-3  col-12"
                                          : "col-md-6  col-12"
                                      ]
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: "Tipo de Documento",
                                          rules: "required"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function({ errors }) {
                                                return [
                                                  _c("custom-drop-down", {
                                                    staticClass: "mt-1",
                                                    attrs: {
                                                      "custom-error-msg":
                                                        "Favor seleccionar tipo de documento.",
                                                      error: errors[0],
                                                      fieldkey: "id",
                                                      fieldname: "name",
                                                      label:
                                                        "Tipo de Documento:",
                                                      options:
                                                        _vm.documentTypes,
                                                      placeholder: "Seleccione"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.eligibility
                                                          .documentType,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.eligibility,
                                                          "documentType",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "eligibility.documentType"
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _vm.isOtherDocument
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-md-3 col-12 mt-3 mt-md-0"
                                        },
                                        [
                                          _c("validation-provider", {
                                            attrs: {
                                              name: "Nombre del Documento",
                                              rules: "required"
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function({ errors }) {
                                                    return [
                                                      _c("custom-input", {
                                                        staticClass: "mt-1",
                                                        attrs: {
                                                          "custom-error-msg":
                                                            "Favor ingresar el nombre del documento",
                                                          error: errors[0],
                                                          label:
                                                            "Nombre del Documento:",
                                                          placeholder:
                                                            "Ingrese el nombre del documento"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.eligibility
                                                              .otherName,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.eligibility,
                                                              "otherName",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "eligibility.otherName"
                                                        }
                                                      })
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-md-6 col-12 mt-3 mt-md-0"
                                    },
                                    [
                                      _c("validation-provider", {
                                        attrs: {
                                          name: "Archivo",
                                          rules: "required"
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function({ errors }) {
                                                return [
                                                  _c(
                                                    "label",
                                                    {
                                                      staticClass: "text-muted"
                                                    },
                                                    [_vm._v("Archivo:")]
                                                  ),
                                                  _c("custom-file-input", {
                                                    ref: "documentInform",
                                                    staticClass: "mt-1",
                                                    attrs: {
                                                      accept: "pdf",
                                                      "attachment-id":
                                                        _vm.eligibility
                                                          .documentId,
                                                      "custom-error-msg":
                                                        "Favor seleccionar un archivo.",
                                                      "display-style": "normal",
                                                      error: errors[0],
                                                      "on-download": () => {}
                                                    },
                                                    on: {
                                                      input: function($event) {
                                                        return _vm.saveSignedDocument(
                                                          $event
                                                        )
                                                      }
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.eligibility
                                                          .document,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.eligibility,
                                                          "document",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "eligibility.document"
                                                    }
                                                  })
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          true
                                        )
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    { staticClass: "col-12 text-right mt-4" },
                                    [
                                      _c(
                                        "action-button",
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            i: "fas fa-times-circle",
                                            variant: "outline-danger"
                                          },
                                          on: { click: _vm.onCancel }
                                        },
                                        [_vm._v(" Cancelar ")]
                                      ),
                                      _c(
                                        "action-button",
                                        {
                                          attrs: {
                                            i: "fas fa-flag",
                                            variant: "success"
                                          },
                                          on: {
                                            click: () =>
                                              _vm.onAddEligibility(validate)
                                          }
                                        },
                                        [_vm._v(" Someter ")]
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ])
              ])
            ])
          ])
        : _vm._e(),
      _vm.hasEligibilities
        ? _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("custom-separator", {
                staticClass: "my-4",
                attrs: { text: "Elegibilidad" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.hasEligibilities
        ? _c(
            "div",
            { staticClass: "col-12" },
            _vm._l(_vm.eligibilities, function(item) {
              return _c("medicaid-row-result", {
                key: item.id,
                attrs: { "is-from-company": "", model: item },
                on: { refresh: _vm.onSearchHandler }
              })
            }),
            1
          )
        : _vm._e(),
      _vm.showPagination
        ? _c("pagination", {
            attrs: { data: _vm.pagination, "show-text": "" },
            on: { "pagination-go-page": _vm.goToPageHandler }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }